import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Topbar } from '@/components/layout/Topbar';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import { toast } from 'sonner';
import { api, formatApiError } from '@/lib/api';
import { WrWorkspace } from '@/components/wr/WrWorkspace';

export default function AdminWorkforceRecords() {
  const { t } = useTranslation();
  const [companies, setCompanies] = useState([]);
  const [cid, setCid] = useState('');
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/admin/wr/companies')
      .then((r) => setCompanies(r.data.items || []))
      .catch((e) => toast.error(formatApiError(e)));
  }, []);

  const load = async (companyId) => {
    try {
      const r = await api.get(`/admin/wr/${companyId}/overview`);
      setData(r.data);
    } catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { if (cid) load(cid); }, [cid]); // eslint-disable-line

  return (
    <div data-testid="admin-wr-page">
      <Topbar title="Workforce Records" />
      <div className="p-6 lg:p-8 space-y-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <h1 className="text-2xl font-semibold tracking-tight">{t('wr.title')}</h1>
            <p className="text-base text-muted-foreground mt-1">{t('wr.adminSubtitle')}</p>
          </div>
          <div className="w-full sm:w-80">
            <Select value={cid} onValueChange={setCid}>
              <SelectTrigger className="text-base" data-testid="admin-wr-company-select">
                <SelectValue placeholder={t('wr.selectCompany')} />
              </SelectTrigger>
              <SelectContent>
                {companies.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        {!cid && <p className="text-base text-muted-foreground" data-testid="admin-wr-pick-hint">{t('wr.selectCompanyHint')}</p>}
        {cid && data && (
          <>
            <WrWorkspace t={t} data={data} canEdit={false}
              docMode="admin" docCompanyId={cid}
              fetchDetail={(e, r) => api.get(`/admin/wr/${cid}/records/${e}/${r}`).then((x) => x.data)}
              saveRecord={() => Promise.reject(new Error('read-only'))}
              onSaved={() => {}} />
            {(data.inactive_requirements || []).length > 0 && (
              <Card className="p-6 space-y-2" data-testid="admin-wr-inactive">
                <h3 className="text-lg font-semibold">{t('wr.config.archivedTitle')}</h3>
                <div className="flex flex-wrap gap-2">
                  {data.inactive_requirements.map((r) => (
                    <Badge key={r.id} variant="outline" className="text-sm">{r.name}</Badge>
                  ))}
                </div>
              </Card>
            )}
          </>
        )}
      </div>
    </div>
  );
}
